export default "__VITE_ASSET__D6vMuF3R__"